import { Link } from "react-router-dom";
import { ArrowRight, Sun, Battery, Shield, TrendingUp } from "lucide-react";

export default function PltsTumbuh() {
  const stages = [
    { title: "Starter", kwp: "2–5 kWp", desc: "Mulai dengan kebutuhan inti. Inverter dan jalur kabel disiapkan agar bisa dikembangkan.", icon: Sun },
    { title: "Safer", kwp: "4–9 kWp", desc: "Tambah baterai untuk malam dan beban penting saat pemadaman.", icon: Battery },
    { title: "Signature", kwp: "8–25 kWp", desc: "Cakupan lebih luas, backup lebih panjang. Hanya bila batas rumah dan atap mendukung.", icon: Shield },
  ];
  return (
    <div data-testid="page-plts-tumbuh">
      <div className="pe-container pt-14 pb-10">
        <div className="pe-eyebrow">Konsep</div>
        <h1 className="mt-2 font-display font-bold text-4xl lg:text-5xl max-w-3xl">PLTS Tumbuh — Mulai sesuai kemampuan, tumbuh sesuai kebutuhan</h1>
        <p className="mt-5 text-lg text-[color:var(--pe-text-muted)] max-w-3xl">
          Fondasi engineering yang sama untuk setiap tahap. Kualitas pengerjaan Starter tidak lebih rendah dari Signature — yang berbeda adalah kapasitas, cakupan kebutuhan, dan ketahanan backup.
        </p>
      </div>
      <div className="pe-container pb-16">
        <div className="relative grid md:grid-cols-3 gap-6">
          {stages.map((s, i) => (
            <div key={i} className="pe-card">
              <s.icon className="w-10 h-10 mb-3" style={{ color: "var(--pe-primary)" }} />
              <div className="pe-eyebrow">Tahap {i + 1}</div>
              <h3 className="font-display font-semibold text-xl mt-1">{s.title}</h3>
              <div className="font-mono-spec text-sm mt-1 text-[color:var(--pe-primary)]">{s.kwp}</div>
              <p className="mt-3 text-[color:var(--pe-text-muted)]">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <section className="pe-section bg-[color:var(--pe-bg-soft)]">
        <div className="pe-container">
          <div className="pe-eyebrow">Kenapa bertahap</div>
          <h2 className="mt-2 font-display font-bold text-3xl lg:text-4xl max-w-3xl">Investasi yang bertumbuh bersama rumah</h2>
          <div className="mt-10 grid md:grid-cols-2 gap-6">
            {[
              { t: "Mulai dengan yang paling penting", d: "Siang hari biasanya mudah tertutup PV. Kami pastikan tahap awal menutup pola konsumsi yang paling sering." },
              { t: "Siapkan kabel & inverter untuk tumbuh", d: "Pemilihan model inverter dan jalur kabel memperhitungkan ruang pengembangan panel dan baterai." },
              { t: "Tambahkan baterai saat memang perlu", d: "Baterai bermanfaat jika ada surplus PV untuk mengisinya dan ada kebutuhan malam/backup yang nyata." },
              { t: "Audit ulang setiap tahap", d: "Setiap tambahan dicek ulang terhadap batas inverter, MPPT, atap, dan proteksi listrik." },
            ].map((x, i) => (
              <div key={i} className="pe-card">
                <TrendingUp className="w-7 h-7" style={{ color: "var(--pe-primary)" }} />
                <h3 className="font-display font-semibold text-lg mt-3">{x.t}</h3>
                <p className="mt-2 text-[color:var(--pe-text-muted)]">{x.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pe-section">
        <div className="pe-container text-center">
          <h2 className="font-display font-bold text-3xl lg:text-4xl">Lihat konsep ini untuk rumah Bapak/Ibu</h2>
          <div className="mt-6 flex gap-3 justify-center flex-wrap">
            <Link to="/simulasi" className="pe-btn-primary" data-testid="plts-cta-simulasi">Simulasi 5 Langkah <ArrowRight size={16} /></Link>
            <Link to="/rencana-tumbuh" className="pe-btn-ghost">Rencana Tumbuh</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
